export default __webpack_public_path__ + "78522c335cf34a323661b087b86cd934.csv";